// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import X from "@insite/mobius/Icons/X";
import { costCodesStyles } from "@steiner/Overrides/Widgets/Budget/CostCodes";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { createLinkIconStyles, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

costCodesStyles.gridContainer = {
    gap: 0,
};

costCodesStyles.removeLink = {
    ...createLinkIconStyles({
        icon: X,
        linkStyles: {
            icon: {
                iconProps: {
                    size: 16,
                    css: css`
                        margin-right: 6px;
                    `,
                },
            },
            typographyProps: {
                size: 16,
                lineHeight: 22,
                weight: fontConfig.weight.bold,
            },
        },
    }),
};

costCodesStyles.titleText = {
    variant: "h1",
    as: "h1",
} as any;

costCodesStyles.costCodeTitleText = {
    weight: fontConfig.weight.regular,
    size: 12,
    css: css`
        display: inline-block;
        margin-right: 6px;
    `,
};

costCodesStyles.addCostCodeButton = {
    ...costCodesStyles.addCostCodeButton,
    variant: "primary",
};

costCodesStyles.saveButton = {
    css: css`
        margin-left: 16px;
    `,
};
costCodesStyles.costCodeTitleGridItems = {
    width: [12, 12, 6, 6, 4],
    css: css`
        display: block;
        padding-top: 20px;
    `,
};

costCodesStyles.costCodesTableGridItems = {
    width: [12, 12, 12, 12, 6],
    css: css`
        display: block;
        padding: 24px 0;
    `,
};

costCodesStyles.buttonsGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        justify-content: flex-end;
        ${xScreen("lte", "sm")} {
            padding-bottom: 20px;
            justify-content: flex-start;
            > div[class^="HiddenStyle"] {
                display: flex;
            }
        }
    `,
};

costCodesStyles.addCostCodeButtonGridItems = {
    width: 12,
    css: css`
        padding-bottom: 20px;
    `,
};
